<p-toast [style]="{float: 'left'}" position="center" key="r" [baseZIndex]="1000">
  <ng-template let-content pTemplate="content">
    <div style="text-align: left">
      <h3>{{content.summary}}</h3>
      <div innerHtml="{{content.detail}}">
        <mat-divider>
        </mat-divider>
      </div>
      <button style="float: right" type="button" pButton label="Ok" (click)="messageService.clear();"
      class="ui-button"></button>
    </div>
  </ng-template>
</p-toast>


<div class="container-fluid rate-season-monthly-summary-table rate-summary-report">
  <br>
    <h2 class="mb-0">Rate Season Monthly Summary Report</h2>
    <div class="row justify-content-between">
      <div class="custom-col-left">
        <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true
          [showDevelopments]=false [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=true
          [showSeasons]=false [showStartDate]=true [showYieldMaxProperties]=true [showYieldMaxDevelopments]=true
          [showYieldMaxRateBuckets]=true [showCustomDateRange]="true" [dateRange]="'year'" [showEndDate]=true
        [shortTermRentalId] = "propertyId" (doSearchCB)="onSearchSubmit($event)"></app-search-template>
      </div>
      <div class="custom-col-right d-flex text-start justify-content-end align-items-center">
        @if (totalProperties > 0) {
          <span class="badge rounded-pill text-bg-secondary" style="font-size:0.85rem;padding:0.45em 0.85em;">
            {{ totalProperties }} {{ totalProperties === 1 ? 'Property' : 'Properties' }}
          </span>
        }
      </div>
    </div>
    <br>
      <p-table class="rate-seasons-monthly-summary-table" #dt [value]="advertisedRateRows" [columns]="scrollingColumns" scrollDirection="both" [frozenWidth]="frozenWidth"
        [scrollable]="true" [scrollHeight]="innerHeight +'px'" sortMode="multiple" [loading]="formLoading"
        [ngStyle]="{'width': 'auto'}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of frozenColumns; track col) {
              <th style="width:75px;height:70px;padding: .2em .2em !important;"
                [pSortableColumn]="col.field" pFrozenColumn>
                <div class="d-flex flex-column">
                  {{col.header}}
                  <!-- Sorting Icons -->
                  @if (dt.sortField === col.field) {
                    <i
							[ngClass]="{
								'pi pi-sort-up': dt.sortOrder === 1, 
								'pi pi-sort-down': dt.sortOrder === -1
							}">
                    </i>
                  }
                  @if (dt.sortField !== col.field) {
                    <i class="pi pi-sort"></i>
                  }
                  <div class="d-block w-100">@if (col.field === 'propertyCode') {
                    <input (click)="clickOnFilter($event)" style="width:50px"
                      pInputText type="text"
                      (input)="dt.filter($event.target.value, col.field, 'contains')">
                  }
                </div>
                <div class="d-block w-100">@if (col.field === 'rateBucketName') {
                  <input (click)="clickOnFilter($event)" style="width:50px"
                    pInputText type="text"
                    (input)="dt.filter($event.target.value, col.field, 'contains')">
                }
              </div>
              <div class="d-block w-100">@if (col.field === 'bedrooms') {
                <input (click)="clickOnFilter($event)" style="width:40px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'startsWith')">
              }</div>
              <div class="d-block w-100">@if (col.field === 'annualRevTargetAmnt') {
                <input (click)="clickOnFilter($event)" style="width:40px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'startsWith')">
              }</div>
              <div class="d-block w-100">@if (col.field === 'nightlyRateMonthTTL') {
                <input (click)="clickOnFilter($event)" style="width:40px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'startsWith')">
              }</div>
              <div class="d-block w-100">@if (col.field === 'rateBucketAdjusterPct') {
                <input (click)="clickOnFilter($event)" style="width:50px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')">
              }</div>
            </div>
          </th>
        }
        @for (col of columns; track col) {
          <th
            style="width:236px;height:70px;padding:.2em .2em !important;">
            <div class="d-flex flex-column">
              <!-- <span (click)="toggleSort(col.startDate)"
              style="cursor:pointer; font-weight:bold;"> -->
              <span>
                {{ col.header }}
                <!-- <i *ngIf="sortingState[col.startDate] === 'asc'" class="pi pi-sort-amount-up"></i>
                <i *ngIf="sortingState[col.startDate] === 'desc'" class="pi pi-sort-amount-down"></i> -->
              </span>
              <small style="padding-top: 2px;">
                <a (click)="sortBy(col.startDate, 'nightlyRateTTL', $event)"
                  style="cursor:pointer; color:blue; margin-right:6px;">
                  Actual $
                  @if (sortingState[col.startDate]?.nightlyRateTTL === 'asc') {
                    <i
                    class="pi pi-sort-amount-up ml-1"></i>
                  }
                  @if (sortingState[col.startDate]?.nightlyRateTTL === 'desc') {
                    <i
                    class="pi pi-sort-amount-down ml-1"></i>
                  }
                </a>
                <a (click)="sortBy(col.startDate, 'expectedRoomRateTtl', $event)"
                  style="cursor:pointer; color:green;">
                  Expected $
                  @if (sortingState[col.startDate]?.expectedRoomRateTtl === 'asc') {
                    <i
                    class="pi pi-sort-amount-up ml-1"></i>
                  }
                  @if (sortingState[col.startDate]?.expectedRoomRateTtl === 'desc') {
                    <i
                    class="pi pi-sort-amount-down ml-1"></i>
                  }
                </a>
              </small>
              <small style="padding-top: 2px;">
                <a (click)="sortBy(col.startDate, 'totalAchievedRevenuePct', $event)"
                  style="cursor:pointer; color:blue; margin-right:6px;">
                  Actual %
                  @if (sortingState[col.startDate]?.totalAchievedRevenuePct === 'asc') {
                    <i
                    class="pi pi-sort-amount-up ml-1"></i>
                  }
                  @if (sortingState[col.startDate]?.totalAchievedRevenuePct === 'desc') {
                    <i
                    class="pi pi-sort-amount-down ml-1"></i>
                  }
                </a>
                <a (click)="sortBy(col.startDate, 'seasonOccupancy', $event)"
                  style="cursor:pointer; color:green;">
                  Expected %
                  @if (sortingState[col.startDate]?.seasonOccupancy === 'asc') {
                    <i
                    class="pi pi-sort-amount-up ml-1"></i>
                  }
                  @if (sortingState[col.startDate]?.seasonOccupancy === 'desc') {
                    <i
                    class="pi pi-sort-amount-down ml-1"></i>
                  }
                </a>
              </small>
            </div>
            <div>
              @if (col.field === 'propertyCode') {
                <input (click)="clickOnFilter($event)" style="width:50px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')">
              }
            </div>
            <div>
              @if (col.field === 'rateBucketName') {
                <input (click)="clickOnFilter($event)" style="width:50px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')">
              }
            </div>
            <div>
              @if (col.field === 'bedrooms') {
                <input (click)="clickOnFilter($event)" style="width:40px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'startsWith')">
              }
            </div>
            <div>
              @if (col.field === 'annualRevTargetAmnt') {
                <input (click)="clickOnFilter($event)" style="width:40px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'startsWith')">
              }
            </div>
            <div>
              @if (col.field === 'nightlyRateMonthTTL') {
                <input (click)="clickOnFilter($event)" style="width:40px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'startsWith')">
              }
            </div>
            <div>
              @if (col.field === 'rateBucketAdjusterPct') {
                <input (click)="clickOnFilter($event)" style="width:50px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')">
              }
            </div>
          </th>
        }

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        @for (col of frozenColumns; track col) {
          <td style="width:75px;height:100px; padding: .2em .2em !important;"
            [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
            [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)"
            pFrozenColumn>
            @if (col.field === 'propertyCode') {
              <span>
                <a style=" text-decoration: none; color: blue;" (click)="onRowSelect(rowData[0])"
                target="_blank">{{rowData[col.field]}}</a>
              </span>
            }
            @if (col.field === 'rateBucketName') {
              <span>
                {{rowData[col.field]}}
              </span>
            }
            @if (col.field === 'bedrooms') {
              <span>
                {{rowData[col.field]}}
              </span>
            }
            @if (col.field === 'annualRevTargetAmnt') {
              <span>
                {{rowData[col.field] | currency : 'USD' : 'symbol' : '1.0-0'}}
              </span>
            }
            @if (col.field === 'nightlyRateMonthTTL') {
              <span>
                {{rowData[col.field] | currency : 'USD' : 'symbol' : '1.0-0'}}
              </span>
            }
            @if (col.field === 'rateBucketAdjusterPct') {
              <span>
                <input #rateBucketAdjusterPct
                  (change)="onRateBucketAdjusterPctChange(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"
                  pInputText type="text" value="{{formatPercent(rowData.rateBucketAdjusterPct)}}"
                  style="width:65px;margin-bottom:3px;">
							<a #cl3 href="javascript:" (click)="onRateBucketAdjusterPctSave(rowData[0].propertyId,rateBucketAdjusterPct.value);rateBucketAdjusterPct.style.backgroundColor = 'transparent';
							cl3.style.visibility = 'hidden';" style="margin-left:2px;visibility:hidden;color:red"><i
                  class="pi pi-save"></i></a>
                  <br>&nbsp;
                    <a #cl1 href="javascript:"
                      (click)="decRateBucketAdjPct(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                    class="pi pi-minus"></i></a>&nbsp;&nbsp;&nbsp;
                    <a #cl2 href="javascript:"
                      (click)="incRateBucketAdjPct(rowData[0].propertyId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                    class="pi pi-plus"></i></a>
                  </span>
                }
              </td>
            }
            @for (col of columns; track col) {
              <td [ngClass]="rowData[col.field]?.occPctTtl >= rowData[col.field]?.seasonOccupancy ? 'main-bx bg-green' : rowData[col.field]?.occPctTtl >= (rowData[col.field]?.seasonOccupancy - 0.3) ? 'main-bx bg-yellow' : 'main-bx bg-pink'"
                [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
                [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)">
                @if (rowData[col.field]) {
                  <span>
                    <span>
                      <span class="d-flex gap-3 mt-3">
                        <span style="width:35px" tabindex="0"
                          class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                          {{rowData[col.field].nightlyRateTTL | currency : 'USD' : 'symbol' : '1.0-0'}}
                        </span>
                        <span style="width:20px" tabindex="0"
                          class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                          ({{rowData[col.field].nightlyRateAvg | currency : 'USD' : 'symbol' : '1.0-0'}})
                        </span>
                        &nbsp;
                        @if (rowData[col.field].ntsInMonthTtl) {
                          <span>
                            <span style="width:33px; display: inline-block;" tabindex="0"
                              class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                              {{rowData[col.field].guestAchievedRevenuePct | percent}}
                            </span>&nbsp;
                            <span tabindex="0"
                              class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                              {{rowData[col.field].expectedGuestRoomRateTtl | currency : 'USD' : 'symbol' :
                              '1.0-0'}}
                            </span>&nbsp;
                          </span>
                        }
                      </span>
                      <span class="d-flex">
                        <span style="width:96px" class="rate-bucket-info">
                        </span>&nbsp;
                        <span style="width:33px; display: inline-block;" tabindex="0"
                          class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                          {{rowData[col.field].totalAchievedRevenuePct | percent}}
                        </span>&nbsp;
                        <span tabindex="0"
                          class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                          {{rowData[col.field].expectedRoomRateTtl | currency : 'USD' : 'symbol' :
                          '1.0-0'}}
                        </span>
                      </span>
                      <span class="d-flex">
                        <span style="width:96px" class="rate-bucket-info">
                        </span>&nbsp;
                        <span style="width:33px; display: inline-block;" tabindex="0"
                          class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                          {{rowData[col.field].seasonOccupancy | percent}}
                        </span>&nbsp;
                      </span>
                      <span class="d-flex">
                        <span style="width:96px" class="rate-bucket-info">
                          <span class="bg-grey" tabindex="0"
                            class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                            {{rowData[col.field].guestResNtsTtl}}d
                          </span>
                          <span class="bg-pink" tabindex="0"
                            class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                            {{rowData[col.field].otherResBookingNtsTtl}}d
                          </span>
                          <span tabindex="0"
                            class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                            {{rowData[col.field].ntsInMonthTtl}}d
                          </span>
                        </span>&nbsp;
                        <span style="width:30px" tabindex="0"
                          class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                          {{rowData[col.field].occPctTtl | percent}}
                        </span>&nbsp;
                        @if (rowData[col.field].occPctTtl == null) {
                          <span style="width:30px" tooltipEvent="focus" tabindex="0" pTooltip="Current occupancy %">
                            0%
                          </span>
                          }&nbsp;
                          @if (rowData[col.field].totalVacantNts != null) {
                            <span class="text-blue" tooltipEvent="focus" tabindex="0" pTooltip="Pending Room Rate Target">
                              {{pendingRoomRateAmount | currency : 'USD' : 'symbol' :
                              '1.0-0'}}
                            </span>
                            }&nbsp;
                            <span class="rate-bucket-info">
                              <span [ngClass]="rowData[col.field].minStayExpectedNtsAvailable ? 'bg-green' : rowData[col.field].totalVacantNts <= 0 ? '' : 'bg-blue'" tabindex="0"
                                class="clickable-value" (click)="openCalculationDialog(rowData[col.field], col)">
                                {{rowData[col.field].totalVacantNts}}d
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    }
                  </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>

        <p-dialog header="Note" [modal]="true" [(visible)]="showNoteWindow"
          [style]="{ width: '50rem', height:'23rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
          [maximizable]="true">
          @if (currentRateBucketDetailId) {
            <app-note-list [noteSource]="80" [noteSourceId]="currentRateBucketDetailId"></app-note-list>
          }
        </p-dialog>

        <p-dialog
          header="Monthly Calculation Details ({{selectedMonthLabel}})"
          [(visible)]="showCalculationDialog"
          [modal]="true"
          [closable]="true"
          [dismissableMask]="true"
          [style]="{ width: '70rem' }"
          [breakpoints]="{ '1200px': '90vw', '768px': '95vw' }"
          >

          @if (selectedMonthResult) {
            <table class="calc-table">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                  <th>Explanation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Actual Room Revenue</td>
                  <td>
                    {{ selectedMonthResult.nightlyRateTTL | currency:'USD':'symbol':'1.0-0' }}
                  </td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.nightlyRateExplanation)"></td>
                </tr>
                <tr>
                  <td>Nightly Rate Avg</td>
                  <td>{{ selectedMonthResult.nightlyRateAvg | currency:'USD':'symbol':'1.0-0' }}</td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.nightlyRateAvgExplanation)"></td>
                </tr>
                <tr>
                  <td>Expected Room Revenue</td>
                  <td>
                    {{ selectedMonthResult.expectedRoomRateTtl | currency:'USD':'symbol':'1.0-0' }}
                  </td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.expectedRoomRateExplanation)"></td>
                </tr>
                <tr>
                  <td>Expected Guest Revenue</td>
                  <td>
                    {{ selectedMonthResult.expectedGuestRoomRateTtl | currency:'USD':'symbol':'1.0-0' }}
                  </td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.expectedRoomRateGuestExplanation)"></td>
                </tr>
                <tr>
                  <td>Total Achieved Revenue %</td>
                  <td>
                    {{ selectedMonthResult.totalAchievedRevenuePct * 100 | number:'1.2-2' }} %
                  </td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails.totalAchievedRevenuePctExplanation)"></td>
                </tr>
                <tr>
                  <td>Guest Achieved Revenue %</td>
                  <td>
                    {{ selectedMonthResult.guestAchievedRevenuePct * 100 | number:'1.2-2' }} %
                  </td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails.guestAchievedRevenuePctExplanation)"></td>
                </tr>
                <tr>
                  <td>Season Occupancy %</td>
                  <td>
                    {{ selectedMonthResult.seasonOccupancy * 100 | number:'1.2-2' }} %
                  </td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails.seasonOccupancyExplanation)"></td>
                </tr>
                <tr>
                  <td>Guest Nights</td>
                  <td>{{ selectedMonthResult.guestResNtsTtl }} nights</td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.guestResNtsExplanation)"></td>
                </tr>
                <tr>
                  <td>Other Nights</td>
                  <td>{{ selectedMonthResult.otherResBookingNtsTtl }} nights</td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.otherResBookingNtsExplanation)"></td>
                </tr>
                <tr>
                  <td>Occupancy</td>
                  <td>{{ selectedMonthResult.occPctTtl | percent }}</td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.occupancyExplanation)"></td>
                </tr>
                <tr>
                  <td>Vacant Nights</td>
                  <td>{{ selectedMonthResult.totalVacantNts }} nights</td>
                  <td [innerHTML]="formatExplanation(selectedMonthResult.calculationDetails?.vacantNtsExplanation)"></td>
                </tr>
              </tbody>
            </table>
            <div class="dialog-footer">
              <button pButton type="button" label="Close" (click)="closeCalculationDialog()"></button>
            </div>
          }
        </p-dialog>

